import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";

export class SurchargeTypeUpdater extends CrudAbstractModel {
  constructor(
    public id: number,
    public active: boolean = true,
    public marginPercentage?: number,
    public shipmentPrice?: number,
    public pricePer100Kg?: number,
    public pricePer100KgReal?: number,
    public pricePerPiece?: number,
    public pricePerPallet?: number,
    public minPrice?: number,
    public maxPrice?: number,
  ) {
    super(id);
  }

  public getRequestParams() {
    return {
      active: this.active,
      marginPercentage:
        this.marginPercentage !== null ? this.marginPercentage : undefined,
      shipmentPrice:
        this.shipmentPrice !== null ? this.shipmentPrice : undefined,
      pricePer100Kg:
        this.pricePer100Kg !== null ? this.pricePer100Kg : undefined,
      pricePer100KgReal:
        this.pricePer100KgReal !== null ? this.pricePer100KgReal : undefined,
      pricePerPiece:
        this.pricePerPiece !== null ? this.pricePerPiece : undefined,
      pricePerPallet:
        this.pricePerPallet !== null ? this.pricePerPallet : undefined,
      minPrice: this.minPrice !== null ? this.minPrice : undefined,
      maxPrice: this.maxPrice !== null ? this.maxPrice : undefined,
    };
  }

  public isValid(): boolean {
    return true;
  }

  public getClone(): SurchargeTypeUpdater {
    return new SurchargeTypeUpdater(
      this.id,
      this.active,
      this.marginPercentage,
      this.shipmentPrice,
      this.pricePer100Kg,
      this.pricePer100KgReal,
      this.pricePerPiece,
      this.pricePerPallet,
      this.minPrice,
      this.maxPrice,
    );
  }
}
